import { createStore } from "vuex";
import webshopModule from "./webshop-module";
import dataModule from "./data-module";
import orderModule from "./orders-module";

const DEFAULT_APPID = "demo";

export default createStore({
  modules: {
    webshop: webshopModule,
    data: dataModule,
    orders: orderModule,
  },
  state: () => ({
    appId: DEFAULT_APPID,
  }),
  mutations: {
    setAppId: (state, appId) => (state.appId = appId),
  },
});
